import { useTranslation } from '../../i18n';

export default function ConnectorAB() {
  const { dict } = useTranslation();
  return (
    <>
      <div className="connector">
        <div className="conn-col down">
          <div className="conn-line-top" />
          <span className="conn-chip cc-dn">{dict.conn_ab_dn}</span>
          <svg width="12" height="10" viewBox="0 0 12 10" fill="none" style={{ flexShrink: 0 }}>
            <path d="M6 9L1 1h10L6 9Z" fill="#534AB7" />
          </svg>
          <div className="conn-line-bottom" style={{ flex: 0.3 }} />
        </div>
        <div className="conn-col up">
          <div className="conn-line-bottom" style={{ flex: 0.3 }} />
          <svg width="12" height="10" viewBox="0 0 12 10" fill="none" style={{ flexShrink: 0 }}>
            <path d="M6 1L11 9H1L6 1Z" fill="#0F6E56" />
          </svg>
          <span className="conn-chip cc-up">{dict.conn_ab_up}</span>
          <div className="conn-line-top" />
        </div>
      </div>
      <div className="conn-note-row">
        <div className="conn-note-item">{dict.conn_ab_dn_note}</div>
        <div className="conn-note-item">{dict.conn_ab_up_note}</div>
      </div>
    </>
  );
}
